import React from "react";

export const SettingsIcon3 = ({ isActive, ...props }: SvgIconProps) => {
  return (
    <svg width={18} height={14} viewBox="0 0 20 14" fill="none" {...props}>
      <path
        d="M3 13V8.333M3 5.667V1M8.333 13V7M8.333 4.333V1M13.667 13V9.667M13.667 7V1M1 8.333h4M6.333 4.333h4M11.667 9.667h4"
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
